module.exports = __webpack_public_path__ + "static/media/icone_sucesso.55fb775c.svg";